import { BooksService, GutendexBook, Language } from '@shared/openapi/jaaluu-api';
import axios from 'axios';
import { Ref, ref } from 'vue';
import { error } from '.';

const GUTINDEX_URL = 'https://gutendex.com/books';
const RESTRICTED_AUTHORS = ['Mann, Thomas', 'Döblin, Alfred'];

const isRestricted = (b: GutendexBook) =>
  b.authors.map((a) => a.name).some((an) => RESTRICTED_AUTHORS.includes(an));

export default () => {
  const books: Ref<GutendexBook[]> = ref([]);
  const { handleDefaultError } = error.funcs;

  const getBooks = (load: number, lang: Language) => {
    return BooksService.getBooksListV1BooksListGet({
      query: { languages: lang, author_year_start: 1900, mime_type: 'text' }
    })
      .then((res) => {
        if (res.data) {
          books.value = res.data.results.filter((b) => !isRestricted(b)).slice(0, load);
        }
      })
      .catch(handleDefaultError);
  };

  const getBook = (id: number) => {
    return axios.get(`${GUTINDEX_URL}/${id}`);
  };

  const getBookContent = (book_url: string) => {
    return BooksService.getBookContentV1BooksContentBookUrlGet({ path: { book_url } }).then(
      (res) => {
        console.log(res);
        return res.data;
      }
    );
  };

  const searchBooks = (search: string, lang: Language, _books: any) => {
    return BooksService.getBooksListV1BooksListGet({
      query: { languages: lang, author_year_start: 1900, mime_type: 'text', search }
    })
      .then((res) => {
        if (res.data) {
          _books.push(...res.data.results.filter((b) => !isRestricted(b)));
        }
      })
      .catch(handleDefaultError);
  };

  return {
    state: { books },
    funcs: { getBooks, searchBooks, getBook, getBookContent }
  };
};
